import { useState, useEffect } from 'react'

import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { toast } from '@sales-center/components'
import { getCompanySetup } from '@user/store/companySetup/api'

export const useGetCompanySetupOnMount = () => {
  const dispatch = useAppDispatch()
  const [status, setStatus] = useState<'pending' | 'success' | 'fail'>(
    'pending',
  )

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      try {
        const result = await dispatch(getCompanySetup())

        if (mounted) {
          if (getCompanySetup.fulfilled.match(result)) {
            setStatus('success')
          } else {
            setStatus('fail')
            toast.error(`Error loading company info: ${result.payload}`)
          }
        }
      } catch (error) {
        if (mounted) {
          setStatus('fail')
        }
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch])

  return status
}
